// view
export interface AgreementView {
    id: number;
    name: string;
    agreementDate: string;
    learningLanguage: LearningLanguage;
    lessonFormat: LessonFormat;
    teacherId: number;
    teacherFullName: string;
    teacherRate: number;
    lessonPrice: number;
    enabled: boolean;
}


// usual
export interface Agreement {
    id: number;
    name: string;
    agreementDate: string;
    learningLanguage: LearningLanguage;
    lessonFormat: LessonFormat;
    teacherId: number;
    teacherRate: number;
    enabled: boolean;
}


// structure
export interface AgreementStructure {
    id: number;
    name: string;
    agreementDate: string;
    learningLanguage: LearningLanguage;
    lessonFormat: LessonFormat;
    teacher: AgreementTeacherStructure;
    enabled: boolean;
    students: AgreementStudentStructure[];
}

export interface AgreementStudentStructure {
    id: number;
    lessonPrice: number;
    availableLessons: number;
    firstName: string;
    lastName: string;
    telegram?: string | null;
}

export interface AgreementTeacherStructure {
    id: number;
    teacherRate: number;
    firstName: string;
    lastName: string;
}

// enums
export enum LearningLanguage {
    ENGLISH = 'ENGLISH',
    SPANISH = 'SPANISH'
}

export const LearningLanguageNameMap = {
    [LearningLanguage.ENGLISH]: 'Английский',
    [LearningLanguage.SPANISH]: 'Испанский'
}

export enum LessonFormat {
    INDIVIDUAL = 'INDIVIDUAL',
    PAIR = 'PAIR',
    GROUP = 'GROUP'
}

export const LessonFormatNameMap = {
    [LessonFormat.INDIVIDUAL]: 'Индивидуальный',
    [LessonFormat.PAIR]: 'Парный',
    [LessonFormat.GROUP]: 'Групповой'
}


// Create request
export interface AgreementCreateRequest {
    name: string;
    agreementDate: string;
    learningLanguage: LearningLanguage;
    lessonFormat: LessonFormat;
    teacherId: number;
    teacherRate: number;
    students: AgreementStudentCreateRequest[];
}

export interface AgreementStudentCreateRequest {
    studentId: number;
    lessonPrice: number;
    availableLessons: number;
}


// Update request
export interface AgreementUpdateRequest {
    name?: string;
    teacherId: number;
    teacherRate: number;
    students: AgreementStudentUpdateRequest[];
}

export interface AgreementStudentUpdateRequest {
    studentId: number;
    lessonPrice: number;
    availableLessons: number;
}

// Agreement Student History
export interface AgreementStudentHistoryView {
    id: number;
    availableLessonsChange: number;
    availableLessonsBefore: number | null;
    availableLessonsAfter: number | null;
    changeReason: AgreementStudentChangeReason;
    createdAt: string;
    userFullName: string;
}

export enum AgreementStudentChangeReason {
    PAYMENT_MADE = 'PAYMENT_MADE',
    LESSON_STATE_CHANGE = 'LESSON_STATE_CHANGE',
    LESSON_DELETED = 'LESSON_DELETED',
    MANUAL_CHANGE = 'MANUAL_CHANGE',
    AGREEMENT_CREATED = 'AGREEMENT_CREATED'
}

export const AgreementStudentChangeReasonNameMap = {
    [AgreementStudentChangeReason.PAYMENT_MADE]: 'Оплата урока',
    [AgreementStudentChangeReason.LESSON_STATE_CHANGE]: 'Изменение состояния урока',
    [AgreementStudentChangeReason.LESSON_DELETED]: 'Урок удален',
    [AgreementStudentChangeReason.MANUAL_CHANGE]: 'Ручное обновление договора',
    [AgreementStudentChangeReason.AGREEMENT_CREATED]: 'Создание договора'
}